import * as Animate from "react-reveal";
import PartnerLogo1 from "../../../assets/images/png/partner-logo/ms_logo.webp";
import PartnerLogo2 from "../../../assets/images/png/partner-logo/coronation.webp";
import PartnerLogo3 from "../../../assets/images/png/partner-logo/binance.webp";
import PartnerLogo4 from "../../../assets/images/png/partner-logo/Diageo.svg.png";
import PartnerLogo5 from "../../../assets/images/png/partner-logo/FCMB_Logo.png";
import PartnerLogo6 from "../../../assets/images/png/partner-logo/Wema-Bank-Logo.png";
import PartnerLogo7 from "../../../assets/images/png/partner-logo/hp.png";
import PartnerLogo8 from "../../../assets/images/png/partner-logo/FrieslandCampina_logo.svg";

const logos = [
  PartnerLogo1,
  PartnerLogo2,
  PartnerLogo3,
  PartnerLogo4,
  PartnerLogo5,
  PartnerLogo6,
  PartnerLogo7,
  PartnerLogo8,
];

const BusinessLogoStripSection = () => {
  return (
    <section className="bg-hire-tint-blue py-16 md:py-20 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-end mb-10">
            <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase order-2 lg:order-1">
              <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
              Trusted ecosystem
            </p>
            <h2 className="lg:col-span-2 order-1 lg:order-2 text-2xl md:text-3xl font-poppins leading-tight font-black text-primary tracking-[-0.03em]">
              Talent from the Utiva ecosystem works across leading companies.
            </h2>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {logos.map((logo, index) => (
            <div
              key={index}
              className="h-20 bg-white border border-hire-line rounded-xl flex items-center justify-center px-5"
            >
              <img
                src={logo}
                alt=""
                className="h-8 w-auto max-w-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessLogoStripSection;
